import { RouteIntercept } from "../../../../redux/services/types";
import RouteInterceptSummary from "../../../../components/RouteIntercept/RouteInterceptSummary";
import { Icon } from "@livingmap/core-ui-v2";
import { useState } from "react";
import RouteStepBanner from "../../../../components/RouteStepBanner/RouteStepBanner";
import { useGetRouteMilestonesProps } from "../../../../hooks/useGetRouteMilestonesProps";
import {
  DisplayUnitSystem,
  RouteMilestoneFeature,
} from "../../../../redux/services/types";
import RouteStepSeparator from "../RouteStepSeparator/RouteStepSeparator";
import styles from "./RouteContent.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  intercept?: RouteIntercept;
  routeMilestones: RouteMilestoneFeature[];
  totalTime: number;
  displayUnit: DisplayUnitSystem;
  language: string;
  showTime?: boolean;
  showStepOption?: boolean;
}

export default function RouteContent({
  intercept,
  routeMilestones,
  totalTime,
  showTime,
  displayUnit,
  language,
  showStepOption,
}: Props) {
  const { t } = useTranslation();

  const [displaySteps, setDisplaySteps] = useState(!showStepOption);

  const handleOnClick = () => {
    setDisplaySteps(!displaySteps);
  };
  const routeMilestonesProps = useGetRouteMilestonesProps({
    routeMilestones,
    totalTime,
    displaySteps,
    displayUnit,
    language,
  });

  if (showStepOption && routeMilestones.length > 3) {
    routeMilestonesProps.splice(1, 0, {
      accent: false,
      text: "show/hide",
      subText: "",
      icon: "WalkingPersonIcon",
      time: "",
    });
  }

  if (!displaySteps && routeMilestonesProps.length) {
    routeMilestonesProps[routeMilestonesProps.length - 1].accent = true;
  }

  const children = routeMilestonesProps.map((props, index) => {
    if (props.text === "show/hide") {
      return (
        <RouteStepSeparator displaySteps onClick={handleOnClick} key={index} />
      );
    } else {
      return (
        <RouteStepBanner
          {...props}
          className={styles.milestone}
          dataQA="route-step-banner-item"
          key={index}
          time={showTime ? props.time : undefined}
        />
      );
    }
  });

  return (
    <>
      <RouteInterceptSummary intercept={intercept} inset={false} />
      <div className={styles.warning}>
        <Icon
          type="WarningIcon"
          dataQA="warning-icon"
          className={styles.icon}
        />
        <p className={styles.text}>{t("navigate_page.caution_message")}</p>
      </div>
      <div className={styles.routeMilestones}>{children}</div>
    </>
  );
}
